export default __webpack_public_path__ + "static/fCfJkvyY-52ed39863b729a115d574c5fb9b31550.svg";